import { useStreamAnalyser } from '@heidi/calls';
import { useEffect } from 'react';

import { VoiceBarVisualizer } from './VoiceBarVisualizer';

interface VoiceOrbProps {
  stream: MediaStream | null;
  active: boolean;
  /** Kept for call-site compat; bar strip uses a fixed compact height. */
  height?: number;
  /** Optional bar colour override; theme text-secondary when omitted. */
  colors?: [string, string, string];
}

/**
 * Live mic equaliser for the speech pill. Uses the shared stream analyser so
 * bars react to the clinician's voice (idle breathing when quiet).
 */
export function VoiceOrb({ stream, active, colors }: VoiceOrbProps) {
  const { amplitude, bands, connectStream, disconnect } = useStreamAnalyser();

  useEffect(() => {
    if (stream) {
      connectStream(stream);
      return () => disconnect();
    }
    return undefined;
  }, [stream, connectStream, disconnect]);

  return (
    <div className="w-full px-1" aria-hidden>
      <VoiceBarVisualizer
        amplitude={amplitude}
        bands={bands}
        active={active}
        color={colors?.[1]}
      />
    </div>
  );
}
